import axios from "axios";

export const getEventVenues = (careersClientId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/eventvenues/" + encodeURIComponent(careersClientId)
    )
    .then((res) => res.data);
};

export const addEventVenue = (json) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/eventvenues/addeventvenue",
      json
    )
    .then((res) => res.data);
};

export const deleteEventVenue = (venueId) => {
  return axios
    .delete(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/eventvenues/deleteeventvenue/" +
        encodeURIComponent(venueId)
    )
    .then((res) => res);
};

export const editEventVenue = (editedVenue) => {
  return axios
    .put(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/eventvenues/editeventvenue",
      editedVenue
    )
    .then((res) => res);
};
